// extracted by mini-css-extract-plugin
export var dropdownMenu = "VersionDropdown-module--dropdownMenu--70180";
export var infoIcon = "VersionDropdown-module--infoIcon--d05d0";